.hero-slider-tile {
  text-decoration: none;
  width: 100%;
  height: 100%;
  max-height: 970px;
  max-width: 1600px;
  position: relative;

  ::slotted(lilu-bubble) {
    position: absolute;
    top: 160px;
    right: 350px;

    @include breakpointMax("xl") {
      top: 100px;
      right: 270px;
    }

    @include breakpointMax("md") {
      top: auto;
      right: auto;
      bottom: 240px;
      left: 30px;
    }

    @include breakpointMax("sm") {
      left: 20px;
    }
  }

  ::slotted(lilu-heading) {
    position: absolute;
    top: 42%;
    left: 100px;
    margin-right: 20px;

    @include breakpointMax("md") {
      top: 18%;
    }

    @include breakpointMax("md") {
      left: 30px;
    }

    @include breakpointMax("sm") {
      left: 20px;
    }
  }

  ::slotted(img) {
    max-height: 970px;
    max-width: 1600px;
    height: 100%;
    width: 100%;
    min-height: 485px;
    object-fit: cover;
  }

  ::slotted(video) {
    max-height: 970px;
    max-width: 1600px;
    height: 100%;
    width: 100%;
    min-height: 485px;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    ::slotted([slot='imageMobile']) {
      display: block !important;
    }

    ::slotted([slot='imageDesktop']) {
      display: none !important;
    }
  }

  @media (min-width: 768px) {
    ::slotted([slot='imageMobile']) {
      display: none !important;
    }

    ::slotted([slot='imageDesktop']) {
      display: block !important;
    }
  }

}
